module.exports = __webpack_public_path__ + "img/2.cba3b4bf.png";